/**
 * Como um texto vindo de fora entra no rascunho que o atendente já digitou.
 *
 * Função pura e separada do contexto porque a regra é o que importa: inserir
 * não pode apagar o que a pessoa escreveu, nem colar palavra na palavra.
 */
export const acrescentarAoRascunho = (atual, texto) => {
  const novo = String(texto == null ? "" : texto).trim();
  if (!novo) return String(atual == null ? "" : atual);

  const anterior = String(atual == null ? "" : atual);
  if (!anterior) return novo;

  // Já termina com espaço ou quebra: não inventa outro.
  return /\s$/.test(anterior) ? anterior + novo : anterior + " " + novo;
};
